import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SpeakerNotesOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"speaker_notes_off"}/>
}
